import React, { useContext } from 'react';
import projectContext from '../../context/projects/projectContext';
import taskContext from '../../context/tasks/taskContext';
import Task from './Task';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const TaskList = () => {

    // Import the state of project
    const projectsContext = useContext(projectContext);
    const { project, deleteProject } = projectsContext;
    
    // Get the state of the tasks of an project
    const tasksContext = useContext(taskContext);
    const { projectTasks } = tasksContext;

    // Validates if any project is selected
    if(!project) return <h2> Please select a project </h2>;
    
    // Destructuring for extract the project
    const [ actualProject ] = project;

    //const projectTasks = [];

    // Delete a project
    const handleDelete = () => {
        deleteProject( actualProject._id );
    }

    return (
        <>
            <h2>Project: { actualProject.name }</h2>
            <ul className="listado-tareas">
                {
                    projectTasks.length === 0
                        ? ( <li className="tarea"><p>Any task to show</p></li> )
                        :   
                        <TransitionGroup>
                        {
                            projectTasks.map(task => (
                                <CSSTransition
                                    key={ task._id }
                                    timeout={ 300 }
                                    classNames="tarea"
                                >
                                    <Task 
                                        task={ task }
                                    />
                                </CSSTransition>
                            ))
                        }
                        </TransitionGroup>
                }
            </ul>
            <button
                type="button"
                className="btn btn-eliminar"
                onClick={ handleDelete }
            >
                Delete Project &times;
            </button>
        </>
    );
}
 
export default TaskList;